export default {"src":"/_next/static/media/info-circle.6458140f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};